import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { auth0Scope, saveAuthUser } from '@flintmint/web-shared/hooks/use-auth-user';
import { appRoutes } from '@/constants/routes';

export const Login = () => {
  const navigate = useNavigate();
  const { user: authUser, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (authUser) {
      saveAuthUser(authUser);
      navigate(appRoutes.home, { replace: true });
    }

    if (!authUser && !isLoading) {
      loginWithRedirect({
        authorizationParams: {
          scope: auth0Scope,
        },
      }).catch(console.error);
    }
  }, [authUser, isLoading, navigate, loginWithRedirect]);

  return <div>Loading...</div>;
};
